import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPropertyObj} from '../../../generated/generated-core.model';


export interface MxApplicationPropertiesService {
    getProperty(name: string): Observable<string>;
    getProperties(): Observable<Array<ApplicationPropertyObj>>;
    addProperty(property: ApplicationPropertyObj): Observable<ApplicationPropertyObj>;
    updateProperty(id: number, property: ApplicationPropertyObj): Observable<ApplicationPropertyObj>;
    removeProperties(ids: Array<number>): Observable<Array<number>>;
    getBooleanProperty(name: string): Observable<boolean>;
}

export const MX_APPLICATION_PROPERTY_SERVICE_TOKEN = new InjectionToken<MxApplicationPropertiesService>('MX_APPLICATION_PROPERTY_SERVICE_TOKEN');
